import { AccessorsMutatorsDecorator, isInstanceOf } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Country } from "./country.model";
import { Property } from "./property.model";

/**
 * @class City
 * @property {number} id
 * @property {string} name
 * @property {Country} country
 * @property {string} status
 */
export class City extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'name' ];
    }

    /**
     * @param {Object|Country} value
     * @returns {Country}
     */
    setCountry(value) {

        if (typeof value === 'undefined') {

            return value;
        }

        return value instanceof Country ? value : new Country(value);
    }
    
    setProperties(value) {
        
        if (!Array.isArray(value) || !isInstanceOf(Property, value[0])) {
            
            value = Property.factory(value);
        }
        
        return value;
    }
    
    static get validationModel() {

        return {
            name: {
                label: 'CITY_NAME_IN_ENGLISH',
                commonLabel: 'City Name',
            },
            name_ar: {
                label: 'CITY_NAME_IN_ARABIC',
                commonLabel: 'City Name',
            },
            country: {
                label: 'COUNTRY'
            }
        };
    }
}

AccessorsMutatorsDecorator('id', ...City.translatableAttributesWithLanguageAliases, 'country', 'status', 'properties', 'guests', 'billing_informations')(City);


// WEBPACK FOOTER //
// ./src/pms-api/models/city.model.js